import { render } from "./AllProfilesView.vue?vue&type=template&id=afeb002a"
import script from "./AllProfilesView.vue?vue&type=script&lang=js"
export * from "./AllProfilesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__